import { useEffect } from 'react';
import { isEmbedded, sendResizeMessage } from '../utils/embedMessaging';

// Observa el contenedor del widget y avisa a la página padre (vía postMessage) de su altura real
// cada vez que cambia, para que el <iframe> que lo embebe pueda ajustarse dinámicamente en lugar
// de usar una altura fija (el wizard tiene pasos con alturas muy distintas: mapa, catálogo, formularios...).
export const useIframeAutoResize = () => {
  useEffect(() => {
    if (!isEmbedded()) return undefined;

    const target = document.getElementById('booking-widget') || document.body;

    const reportHeight = () => {
      sendResizeMessage(target.scrollHeight);
    };

    reportHeight();

    const resizeObserver = new ResizeObserver(reportHeight);
    resizeObserver.observe(target);
    window.addEventListener('resize', reportHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', reportHeight);
    };
  }, []);
};
